export const openDataBase = () => {
    return new Promise((resolve, reject) => {
        const solicitud = indexedDB.open("sirMobile", 5);
        solicitud.onupgradeneeded = (evento) => {
            const db = evento.target.result;
            const store = db.createObjectStore('pyshicalTake', { keyPath: "id" });;
            store.createIndex("value", "value", { unique: false });
        };
        solicitud.onsuccess = (evento) => resolve(evento.target.result);
        solicitud.onerror = (evento) => reject("Error al abrir la base de datos.");
    });
};

export const createElement = (db, model, data) => {
    return new Promise((resolve, reject) => {
        const transaccion = db.transaction([model], "readwrite");
        const store = transaccion.objectStore(model);
        const solicitud = store.add(data);

        solicitud.onsuccess = () => resolve({status: true, data: data});
        solicitud.onerror = () => reject({status: false, message: "Error al agregar el elemento."});
    });
};

export const readElement = (db, model, id) => {
    return new Promise((resolve, reject) => {
        const transaccion = db.transaction([model], "readonly");
        const store = transaccion.objectStore(model);
        const solicitud = store.get(id);

        solicitud.onsuccess = () => resolve({status: true, data: solicitud.result});
        solicitud.onerror = () => reject({status: false, message: "Error al leer el elemento."});
    });
};

export const updateElement = (db, model, data) => {
    return new Promise((resolve, reject) => {
        const transaccion = db.transaction([model], "readwrite");
        const store = transaccion.objectStore(model);
        const solicitud = store.put(data);

        solicitud.onsuccess = () => resolve({status: true, data: data});
        solicitud.onerror = () => reject({status: false, message: "Error al actualizar el elemento."});
    });
};

export const deleteElement = (db, model, id) => {
    return new Promise((resolve, reject) => {
        const transaccion = db.transaction([model], "readwrite");
        const store = transaccion.objectStore(model);
        const solicitud = store.delete(id);

        solicitud.onsuccess = () => resolve({status: true, data: id});
        solicitud.onerror = () => reject({status: false, message: "Error al eliminar el elemento."});
    });
};

export const allElements = (db, model) => {
    return new Promise((resolve, reject) => {
        const transaccion = db.transaction([model], "readonly");
        const store = transaccion.objectStore(model);
        const cursor = store.openCursor();
        const elementos = [];

        cursor.onsuccess = (evento) => {
            const resultado = evento.target.result;
            if (resultado) {
                elementos.push(resultado.value);
                resultado.continue();
            } else {
                resolve({status: true, data: elementos});
            }
        };
        cursor.onerror = () => reject({status: false, message: "Error al obtener los elementos."});
    });
};